import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async sendAnalyticsPageView(rmpBusinessId, adsAccountId, adsAccountName, page) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/analytics/page`,
      { rmpBusinessId, adsAccountId, adsAccountName, page },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async sendAnalyticsLogin(rmpBusinessId, adsAccountId, adsAccountName, rAdproCreateTime) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      "/v1/analytics/login",
      { rmpBusinessId, adsAccountId, adsAccountName, rAdproCreateTime },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
